import React from 'react'
import moment from 'moment'
import { getDateRange, getTimeRange } from './utils'

type Time = string // в формате 20:00:00

interface Props {
  addresses: {
    address: string
    start_date: Date
    end_date: Date
    start_time: Time
    end_time: Time
    festival_date: Date
    festival_start_time: Time
    festival_end_time: Time
  }[]
}

const ContactsAdresses = ({ addresses }: Props) => {
  return (
    <>
      {addresses &&
        addresses.length > 0 &&
        addresses.map((addressItem) => (
          <div
            className="innerPanel"
            style={{ marginTop: '0px' }}
            key={addressItem.address + addressItem.start_date}
          >
            <div className="label">{addressItem.address}</div>
            <div className="timeText">
              <img src="/static/images/clock.svg" alt="" />
              <div>
                <div>
                  <span className="date">
                    {getDateRange(addressItem.start_date, addressItem.end_date)}
                  </span>
                  <span>
                    {getTimeRange(addressItem.start_time, addressItem.end_time)}
                  </span>
                  <br />
                  {addressItem.festival_date &&
                    addressItem.festival_start_time &&
                    addressItem.festival_end_time && (
                      <>
                        <span className="date">
                          {moment(addressItem.festival_date).format('DD.MM')}
                        </span>
                        <span>
                          {getTimeRange(
                            addressItem.festival_start_time,
                            addressItem.festival_end_time
                          )}
                        </span>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  )
}

export default ContactsAdresses
